import { datadogRum } from '@datadog/browser-rum';

export const navigateToUrl = (url: string, context?: string): void => {
  datadogRum.addAction('navigate', context ? { url, context } : { url });
  setLocationHref(url);
};

// Thin wrappers around window.location navigation. jsdom 26 (Jest 30) makes window.location
// non-configurable, so its methods can no longer be spied/mocked directly in tests — prefer these
// and mock this module (jest.mock('@/utils/navigation')) to assert navigation intent.
export const assignLocation = (url: string): void => {
  window.location.assign(url);
};

export const replaceLocation = (url: string): void => {
  window.location.replace(url);
};

export const reloadPage = (): void => {
  window.location.reload();
};

export const setLocationHref = (url: string): void => {
  window.location.href = url;
};
